import styled from "styled-components";
import { AppButton } from "@/shared/components";
import { LegalDocumentModal } from "@/shared/legal/LegalDocumentModal";
import { PaymentTermsDocument } from "@/shared/legal/PaymentTermsDocument";
import { PAYMENT_TERMS_TITLE, SHOW_ADMINISTRATION_FEE } from "@/shared/legal/administrationFee";

interface Props {
	open: boolean;
	onAccept: () => void;
	onClose: () => void;
}

const PAYMENT_TERMS_META = {
	title: PAYMENT_TERMS_TITLE,
	version: "Version 1.1",
	companyName: "CREATOR PAYMENTS INTERNATIONAL PTE. LTD.",
	companyLine: "UEN 202629513M · 69 Circular Road, #02-01, Singapore 049423",
	effectiveDate: "1 October 2026",
	lastUpdated: "1 October 2026",
};

const AcceptButton = styled(AppButton)`
	width: min(392px, 100%);
	height: auto;
	min-height: 40px;
	white-space: normal;
`;

// Opened from inside the onboarding modal, so it uses the drawer variant.
export const CreatorPaymentTermsModal = ({ open, onAccept, onClose }: Props) => (
	<LegalDocumentModal
		open={open}
		onClose={onClose}
		meta={PAYMENT_TERMS_META}
		variant="drawer"
		zIndex={2600}
		footer={
			<>
				<AppButton type="button" onClick={onClose}>
					Cancel
				</AppButton>
				<AcceptButton type="button" variant="primary" onClick={onAccept}>
					I agree to the Terms of Service{SHOW_ADMINISTRATION_FEE ? " and Fee Schedule" : ""}
				</AcceptButton>
			</>
		}
	>
		<PaymentTermsDocument embedded />
	</LegalDocumentModal>
);
